export type QuoteInfosTab = 'Details' | 'ProductDump';

export interface QuoteInfosState {
  activeTab: QuoteInfosTab;
  expanded: Record<string, boolean>;
}

export const initialQuoteDetailUiState: QuoteInfosState = {
  activeTab: 'Details',
  expanded: {},
};

export interface QuoteDetailUiState {
  [tabId: string]: QuoteInfosState;
}
